import React, { Component } from 'react'

import Aux from '../Auxiliary/Auxiliary'
import AuthPanel from '../../containers/AuthPanel/AuthPanel.js'

class AuthLayout extends Component {
  render() {
    return (
      <Aux>
        <AuthPanel {...this.props} />
      </Aux>
    )
  }
}

export default AuthLayout
